import Client from "./base/client";

export class CheckoutInfo {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  private resourceUrl = "/api/checkout";
  private resourceUrlV2 = "/api/v2";

  fetchInfo = <TData extends object>({
    sel,
    registration,
  }: {
    sel: string;
    registration: string;
  }): Promise<TData> =>
    this.client.get(
      `${this.resourceUrlV2}/checkout/info?sel=${sel}&registration=${registration}`
    );

  getCustomiseOptions = () => {
    return this.client.get(`${this.resourceUrl}/customise_plate_options.php`);
  };

  getDeliveryPrices = () => {
    return this.client.get(`/api/v2/checkout/customise/get-delivery-prices`);
  };

  getRegistrationDetails = ({ registration }: { registration: string }) => {
    return this.client.get(
      `${this.resourceUrl}/get_registration_details.php?registration=${registration}`
    );
  };

  getSalesFormMessage = ({ registration }: { registration: string }) => {
    return this.client.get(
      `/api/v2/checkout/get-sales-form-message?registration=${encodeURIComponent(registration)}`
    );
  };

  fetchFinanceOptions = <TData extends object>({
    registration,
  }: {
    registration: string;
  }): Promise<TData> =>
    this.client.get(
      `${this.resourceUrlV2}/finance/options?registration=${registration}`
    );

  payByCard = <TData extends object>({
    registration,
  }: {
    registration: string;
  }): Promise<TData> =>
    this.client.get(`${this.resourceUrl}/buy.php?registration=${registration}`);

  payByFinance = <TData extends object>({
    registration,
    finance,
  }: {
    registration: string;
    finance: boolean;
  }): Promise<TData> =>
    this.client.get(
      `${this.resourceUrl}/buy.php?registration=${registration}&finance=${finance}&marketingId1=search&marketingId2=text`
    );

  storeCustomiseValues = <TData extends object>(data: {
    [key: string]: any;
  }): Promise<TData> =>
    this.client.post(`/api/v2/checkout/customise/store-order-values`, data);

  getOrderValues = <TData extends object>(data: {
    id: string;
  }): Promise<TData> =>
    this.client.post(`/api/v2/checkout/customise/get-order-values`, data);

  submitEnquiry = <TData extends object>(data: {
    [key: string]: any;
  }): Promise<TData> => this.client.post(`/api/v2/checkout/enquiry`, data);
}
